import {
  Calendar,
  Clock,
  User,
  FileText,
  BookOpen,
  NotebookPen,
  FileBadge,
  FileCheck2,
  Edit,
  Trash,
  PlusCircle,
  FileX,
  FileType,
  ImageIcon,
  X,
} from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { SubStdSelContext } from "../../../../SubStdSelContext";
import axios from "../../../../axios";
import { iconData } from "../../../../iconData";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { hasFeature } from "../../../../Utils/features";
import TimeTableJoinNow from "../../../../DCM/components/day-event/Time-table-join-now";
import CreateClassLink from "../../../../DCM/components/CreateClassLink/CreateClassLink";
import YoutubeLiveLink from "../../../../DCM/components/YoutubeLiveLink";

const mapStateToProps = (state) => ({
  inc: state.redres,
  dec: state.redres1,
  ovr: state.redres2,
});

const SummaryLectureUi = ({
  inc,
  dec,
  ovr,
  event,
  scheduleRef,
  readOnly,
  refetch,
  handleDataPopulate,
  SDate,
  EDate,
  setIsCreateLinkClicked,
}) => {
  const navigate = useNavigate();

  const [activity, setActivity] = useState(null);
  const [preRead, setPreRead] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [homework, setHomework] = useState(null);
  const [editfunction, setEditFunction] = useState(false);
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const general_role = localStorage.getItem("general_role");
  const jsonRole_Geinformation = JSON.parse(general_role);
  const [click1, setClick1] = useState(false);
  const [joinNow, setJoinNow] = useState(false);
  const [bookChapterList, setBookChapterList] = useState([]);
  const { secSelectedOption, stdSelectedOption, teacherDCM } =
    useContext(SubStdSelContext);

  const schoolInfo = JSON.parse(localStorage.getItem("UserInformation"));

  const {
    LectureName,
    TeacherName,
    StartTime,
    EndTime,
    Events,
    Supplement_id,
    LectureInstruction = "",
    LectureSummary = "",
  } = event;

  const hasLiveLecture = (event) => {
    return event.Events?.some((e) => e.name === "bbb_lecture") || false;
  };

  const has2WayLecture =
    hasFeature("OL_LEC_2W_NR") || hasFeature("OL_LEC_2W_WR");

  const has1WayLecture =
    hasFeature("OL_LEC_1W_NR") || hasFeature("OL_LEC_1W_WR");

  const hasAnyOnlineLecture = has1WayLecture || has2WayLecture;

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${stdSelectedOption}&section_id=${secSelectedOption}&subject_id=${event.Subject_id}&timetableSessionId=${timeTableSessionId}`,
      );
      if (chapters) {
        setBookChapterList(chapters.data.data[0].bookInfo);
      }
    } catch (error) {
      console.log(error);
      // toast.error("Something went wrong while books and chapter fetching");
    }
  };

  useEffect(() => {
    getDetails();
  }, [click1]);

  useEffect(() => {
    if (teacherDCM === "option3") {
      jsonRole_Geinformation.forEach((element) => {
        if (element.standard_id.id === inc.id) {
          if (element.section_id.id === dec.id) {
            element.subjects_id.forEach((element) => {
              if (element.name === event.Subject) {
                setEditFunction(true);
              } else {
                setEditFunction(false);
              }
            });
          }
        }
      });
    } else {
      setEditFunction(true);
    }
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
      }
    });
  }, [event]);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const formatTime = (dateStr) =>
    new Date(dateStr).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

  const getDurationString = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const diffMs = end - start;
    const totalMinutes = diffMs / (1000 * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours > 0 ? `${hours} Hr${hours > 1 ? "s" : ""}` : ""}${
      minutes > 0 ? ` ${minutes} Min${minutes > 1 ? "s" : ""}` : ""
    }`.trim();
  };

  const eventDataMap = Object.fromEntries(
    (Events || []).map(({ name, value }) => [name, value]),
  );

  const standardsName = localStorage.getItem("stdSelectionName");
  const sectionName = localStorage.getItem("secSelectionName");

  const handleNavigate = () => {
    localStorage.setItem("liveSession", JSON.stringify(event));
    navigate("/liveSession", {
      state: {
        supplement_id: Supplement_id,
        standard_id: stdSelectedOption,
        section_id: secSelectedOption,
        lecture_id: event.Id,
        scheduled_date: event.StartTime,
        end_date: event.EndTime,
        standardsName: standardsName,
        sectionName: sectionName,
      },
    });
  };

  const supplementCount = [
    eventDataMap.assessment,
    eventDataMap.pre_read,
    eventDataMap.homework,
    eventDataMap.activity,
  ].filter(Boolean).length;

  const handleClose = () => {
    scheduleRef?.current?.closeQuickInfoPopup();
  };

  const handleSupplementDetails = async () => {
    try {
      event?.Events?.forEach((obj) => {
        if (obj.name === "activity") {
          axios
            .get(`api/v1/homework/activity/getById/${obj.value}`)
            .then((res) => {
              res && setActivity(res.data.data);
            })
            .catch((err) => console.log(err));
        }
        if (obj.name === "pre_read") {
          axios
            .get(`api/v1/homework/preRead/getById/${obj.value}`)
            .then((res) => {
              res && setPreRead(res.data.data);
            })
            .catch((err) => console.log(err));
        }
        if (obj.name === "assessment") {
          axios
            .get(`api/v1/assessment/get/${obj.value}`)
            .then((res) => {
              res && setAssessment(res.data.data);
            })
            .catch((err) => console.log(err));
        }
        if (obj.name === "homework") {
          axios
            .get(`api/v1/homework/get/${obj.value}`)
            .then((res) => {
              res && setHomework(res.data.data);
            })
            .catch((err) => console.log(err));
        }
      });
    } catch (err) {
      if (err.message === "No Internet Connection") {
        alert("No Internet Connection");
        return;
      }
      console.log(err);
    }
  };
  useEffect(() => {
    handleSupplementDetails();
  }, []);

  const now = Date.now();
    const currentTime = new Date();
  const start = new Date(event.StartTime).getTime();
  const end = new Date(event.EndTime).getTime();

  const isLive = now >= start && now <= end;
  const hasLiveSession = event.Events?.some((e) => e.name === "bbb_lecture");

  const lectureMode = has2WayLecture ? "2WAY" : has1WayLecture ? "1WAY" : null;
  const isHappened = now > end;

  if (!event) return null;
  console.log("event Data from summary",event)

  return (
    <div>
      <div className="mb-2">
        {hasFeature("LEC_SUM") && !readOnly && (
          <div className="d-flex align-items-center justify-content-between">
            <div>
              {hasLiveSession && isLive ? (
                <div className="d-flex justify-content-end mt-1">
                  <TimeTableJoinNow
                    event={event}
                    refetch1={refetch}
                    SDate={SDate}
                    EDate={EDate}
                    setIsCreateLinkClicked={setIsCreateLinkClicked}
                  />
                </div>
              ) : (
                <div
                  className="d-flex justify-content-end"
                  style={{ cursor: "pointer" }}
                >
                  {event?.bbb_lecture_id
                   ? (
                    null
                  ) : (
                    <button
                      disabled={isHappened}
                      onClick={() => {
                        setClick1(true);
                        setIsCreateLinkClicked(true);
                        handleClose();
                      }}
                      className="btn d-flex align-items-center justify-content-center px-2 py-1 fw-bold text-uppercase shadow-sm"
                      style={{
                        backgroundColor: "#fff",
                        color: "#5f2184",
                        border: "2px solid #4169e1",
                        borderRadius: "50px",
                        fontSize: "9px",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                    >
                      Create Online Class
                    </button>
                  )}
                </div>
              )}
            </div>

            <div className="d-flex gap-2">
              {!Supplement_id ? (
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="View Supplement"
                  onClick={handleNavigate}
                >
                  <PlusCircle size={18} />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Edit Supplement"
                  onClick={handleNavigate}
                >
                  <Edit size={18} />
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm  rounded-2 border-2 fw-bold"
                title="Close"
                onClick={handleClose}
              >
                <X size={16} className="text-black" />
              </button>
            </div>
          </div>
        )}
      </div>
      <div className=" rounded-4 p-1 poppins-semibold ">
        <div className=" poppins-semibold ">
          {/* Header */}
          <div
            className="mb-3 p-1 rounded-2"
            style={{ backgroundColor: "#ffebd3", width: "100%" }}
          >
            <h5 className="poppins-semibold  ">
              {LectureName || "Lecture Name"}
            </h5>
            <div className="d-flex flex-wrap gap-3 text-muted small mt-2 poppins-semibold ">
              <span>
                <Calendar size={16} className="me-1" /> {formatDate(StartTime)}
              </span>
              <span>
                <Clock size={16} className="me-1" /> {formatTime(StartTime)}
              </span>

              {/* 3 - Duration */}
              <div
                className="d-flex align-items-start gap-1 "
                style={{
                  // flex: 1,
                  width: "90px",
                }}
              >
                <Clock size={16} style={{ flexShrink: 0 }} />
                <span
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                    fontSize: "13px",
                    lineHeight: "1.2",
                  }}
                  title={getDurationString(StartTime, EndTime)}
                >
                  {getDurationString(StartTime, EndTime)}
                </span>
              </div>
              <div className="d-flex align-items-start justify-content-around w-100 gap-1">
                {/* 1 - Teacher Name */}
                <div
                  className="d-flex align-items-start gap-1"
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <User size={16} style={{ flexShrink: 0 }} />
                  <span
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2, // ✅ 2 lines max
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      fontSize: "13px",
                      lineHeight: "1.2",
                    }}
                    title={TeacherName || "Teacher Name"}
                  >
                    {TeacherName || "Teacher Name"}
                  </span>
                </div>

                {/* 2 - Supplement */}
                <div
                  className="d-flex  gap-1"
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <FileBadge size={16} style={{ flexShrink: 0 }} />
                  <span
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      fontSize: "13px",
                      lineHeight: "1.2",
                    }}
                    title={`Lecture Supplement(${supplementCount})`}
                  >
                    Lecture Supplement({supplementCount})
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="orange-scrollBar"
            style={{ overflowY: "scroll", maxHeight: "250px" }}
          >
            {Events && Events.length === 0 ? (
              <div>{""}</div>
            ) : (
              <>
                {/* Lecture Instruction */}
                {eventDataMap.lecInstruction === "" ||
                !eventDataMap.lecInstruction ? (
                  ""
                ) : (
                  <div className="bg-light rounded p-3 mb-2 d-flex align-items-start">
                    <BookOpen size={20} className="me-2 flex-shrink-0" />
                    <div className="px-1">
                      <h6 className="poppins-semibold  mb-1">
                        Lecture Instruction
                      </h6>
                      <p
                        className="text-muted small  mb-0 poppins-semibold "
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 7,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {eventDataMap.lecInstruction ||
                          "Lorem ipsum dolor sit amet..."}
                      </p>
                    </div>
                  </div>
                )}

                {/* Lecture Summary */}
                {eventDataMap.description === "" ||
                !eventDataMap.description ? (
                  " "
                ) : (
                  <div className="bg-light rounded p-3 mb-2 d-flex flex-row">
                    <NotebookPen size={18} className="me-2 flex-shrink-0" />
                    <div className="">
                      <h6 className=" mb-2 d-flex align-items-center poppins-semibold ">
                        Lecture Summary
                      </h6>
                      <p
                        className="text-muted small mb-0 poppins-semibold "
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 7,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {eventDataMap.description ||
                          "Lorem ipsum dolor sit amet..."}
                      </p>
                    </div>
                  </div>
                )}

                {/* Shared Files */}
                {eventDataMap.attachments &&
                eventDataMap.attachments.length > 0 ? (
                  <div className="bg-light rounded p-3 mb-2 d-flex flex-row">
                    <SharedFiles attachments={eventDataMap.attachments} />
                  </div>
                ) : (
                  ""
                )}

                {/* Lecture Supplements */}
                {(eventDataMap.pre_read ||
                  eventDataMap.assessment ||
                  eventDataMap.homework ||
                  eventDataMap.activity) && (
                  <div className="bg-light rounded p-3 mb-2">
                    <h6 className="fw-semibold mb-3">📚 Lecture Supplements</h6>

                    <div className=" d-flex align-items-center justify-content-around text-center">
                      {eventDataMap.assessment && (
                        <div onClick={localStorage.setItem("from", "DCM")}>
                          <NavLink
                            to="/PublishedQList"
                            state={{ assessmentId: assessment?.id }}
                          >
                            <img
                              src="images/Assessment 2.svg"
                              alt=""
                              style={{
                                width: "26px",
                                height: "26px",
                                objectFit: "contain",
                              }}
                            />
                          </NavLink>
                          <div className="small mt-1 poppins-semibold ">
                            Assessment
                          </div>
                        </div>
                      )}

                      {eventDataMap.pre_read && (
                        <div onClick={localStorage.setItem("from", "DCM")}>
                          <NavLink
                            to={`/PublishedQListPreRead`}
                            state={{ publishPre_id: preRead?.id }}
                          >
                            <img
                              src="images/preRead.svg"
                              alt=""
                              className="icns"
                              style={{
                                width: "24px",
                                height: "24px",
                                objectFit: "contain",
                              }}
                            />
                          </NavLink>
                          <div className="small mt-1 poppins-semibold ">
                            Pre-Read
                          </div>
                        </div>
                      )}

                      {eventDataMap.homework && (
                        <div onClick={localStorage.setItem("from", "DCM")}>
                          <NavLink
                            to={`/PublishedQListHW`}
                            state={{ homework_id: homework?.id }}
                          >
                            <img
                              src="images/Homework 2.svg"
                              alt=""
                              className="icns"
                              style={{
                                width: "24px",
                                height: "24px",
                                objectFit: "contain",
                              }}
                            />
                          </NavLink>
                          <div className="small mt-1 poppins-semibold ">
                            Homework
                          </div>
                        </div>
                      )}

                      {eventDataMap.activity && (
                        <div onClick={localStorage.setItem("from", "DCM")}>
                          <NavLink
                            to={`/PublishedQListActvity`}
                            state={{ publishedActivity_id: activity?.id }}
                          >
                            <img
                              src="images/activity.svg"
                              alt=""
                              className="icns"
                              style={{
                                width: "24px",
                                height: "24px",
                                objectFit: "contain",
                              }}
                            />
                          </NavLink>
                          <div className="small mt-1 poppins-semibold ">
                            Activity
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {eventDataMap.bbb_lecture && (
                  <div className="bg-light rounded p-3 mb-2">
                    <h6 className="fw-semibold mb-3">📚 Online Lecture</h6>

                    <div className=" d-flex align-items-center justify-content-around text-center">
                      {eventDataMap.bbb_lecture && (
                        <div>
                         💻 
                          <div className="small mt-1 poppins-semibold ">
                            Online Lecture
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {click1 &&
        (lectureMode === "2WAY" ? (
          <CreateClassLink
            setClick1={setClick1}
            event={event}
            refetch2={refetch}
            SDate={SDate}
            EDate={EDate}
            bookChapterList={bookChapterList}
          />
        ) : lectureMode === "1WAY" ? (
          <YoutubeLiveLink
            setClick1={setClick1}
            event={event}
            refetch2={refetch}
            SDate={SDate}
            EDate={EDate}
            bookChapterList={bookChapterList}
          />
        ) : null)}
    </div>
  );
};

export default SummaryLectureUi;

const SharedFiles = ({ attachments = [] }) => {
  const getFileIcon = (filename) => {
    const ext = filename?.split(".").pop()?.toLowerCase();

    if (["pdf"].includes(ext))
      return <FileCheck2 size={20} className="text-danger" />;
    if (["doc", "docx"].includes(ext))
      return <FileText size={20} className="text-primary" />;
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext))
      return <ImageIcon size={20} className="text-success" />;
    if (["xls", "xlsx"].includes(ext))
      return <FileType size={20} className="text-success" />;
    return <FileX size={20} className="text-muted" />;
  };
  const getShortName = (file) => {
    const fileName = file.split("/").pop();
    const fileNameWithoutId = fileName.split("_")[1];
    return fileNameWithoutId;
  };

  if (!attachments.length) return null;

  return (
    <div className="d-flex flex-row">
      <FileText size={18} className="me-2" />
      <div>
        <h6 className="poppins-semibold  mb-2 d-flex align-items-center">
          Shared Files ({attachments.length})
        </h6>

        <div className="d-flex flex-row gap-2">
          {attachments.map((file, idx) => {
            let path;
            if (file.startsWith("https://") || file.startsWith("http://")) {
              path = "/images/link-icon.png";
            } else {
              path = `${
                iconData?.find(
                  (i) => i.extension === file?.match(/\.([^.]+)$/)[1],
                )?.icon
              }`;
            }
            return (
              // <div key={idx} >
              //   {getFileIcon(file)}
              // </div>

              <img
                className="d-flex align-items-center gap-2"
                style={{ width: "23px", height: "25px" }}
                src={path}
                alt=""
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
